import { render, staticRenderFns } from "./FloatingUploadingBar.vue?vue&type=template&id=38352b48&scoped=true&"
import script from "./FloatingUploadingBar.vue?vue&type=script&lang=js&"
export * from "./FloatingUploadingBar.vue?vue&type=script&lang=js&"
import style0 from "./FloatingUploadingBar.vue?vue&type=style&index=0&id=38352b48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38352b48",
  null
  
)

export default component.exports